const formLabels = {
  'formLabels.submit': 'Save',
  'formLabels.add': 'Add',
  'formLabels.remove': 'Remove',
  'formLabels.closeAccount': 'Close Account',
  'formLabels.yes': 'Yes',
  'formLabels.no': 'No',
  'formLabels.name': 'Name',
  'formLabels.document_number': 'Document number',
  'formLabels.email': 'Email',
  'formLabels.marital_status': 'Marital Status',
  'formLabels.marital_status.single': 'Single',
  'formLabels.marital_status.married': 'Married',
  'formLabels.marital_status.divorced': 'Divorced',
  'formLabels.marital_status.widower': 'Widower',
  'formLabels.gender': 'Gender',
  'formLabels.gender.f': 'Feminine',
  'formLabels.gender.m': 'Masculine',
  'formLabels.countryCode': 'Country code',
  'formLabels.areaCode': 'Area code',
  'formLabels.phone': 'Phone',
  'formLabels.phoneMessage': 'Message',
  'formLabels.extension': 'Extension',
  'formLabels.phone.residential': 'Home',
  'formLabels.phone.commercial': 'Office',
  'formLabels.phone.mobile': 'Mobile',
  'formLabels.phone.all': 'All',
  'formLabels.phonePlaceholder': '(11) 99999-8888',
  'formLabels.type': 'Type',
  'formLabels.zipcode': 'Zipcode',
  'formLabels.address': 'Address',
  'formLabels.number': 'Number',
  'formLabels.complementary_address': 'Complement',
  'formLabels.main': 'Main',
  'formLabels.country': 'Country',
  'formLabels.state': 'Estate',
  'formLabels.city': 'City',
  'formLabels.neighborhood': 'Neighborhood',
  'formLabels.personalData': 'Profile',
  'formLabels.phones': 'Contact',
  'formLabels.addresses': 'Addresses',
  'formLabels.address.residential': 'Home address',
  'formLabels.address.commercial': 'Commercial address',
  'formLabels.address.all': 'All',
  'formLabels.address.other': 'Other address',
  'formLabels.zip_code': 'Zipcode',
  'formLabels.card_name': 'Card name',
  'formLabels.transaction_limit': 'Transaction limit',
  'formLabels.currentPassword': 'Current Password',
  'formLabels.newPassword': 'New Password',
  'formLabels.newPasswordConfirmation': 'New Password Confirmation',
  'formLabels.mailingAddress': 'Mailing address',
  'formLabels.titleAddressHistoryChangesModal': 'Address History Changes',
  'formLabels.addressCreationDate': 'Creation date',
  'formLabels.addressLastUpdate': 'Last update',
  'formLabels.noAddressRegistered': 'No address registered',
  'formLabels.titlePhoneHistoryChangesModal': 'Phone History Changes',
  'formLabels.phoneCreationDate': 'Creation date',
  'formLabels.phoneLastUpdate': 'Last update',
  'formLabels.noPhoneRegistered': 'No phone registered',
  'formLabels.genericErrorMsg': 'An error occurred. Please try later.',
  'formLabels.active': 'Active',
  'formLabels.inactive': 'Inactive',
  'formLabels.status': 'Status',
  'formLabels.comment': 'Comment',
  'formLabels.all': 'All',
  'formLabels.reason': 'Reason',
  'formLabels.choose': 'Choose',
  'formLabels.status.full_cancellation': 'Account closing',
  'formLabels.status.account_cancellation': 'Account cancellation',
  'formLabels.status.user_cancellation': 'User cancellation',
  'formLabels.status.account_block': 'Account Block',
  'formLabels.status.judicial_block': 'Block',
  'formLabels.status.judicial_unlock': 'Unlock',
  'formLabels.status.normal': 'Normal',
  'formLabels.status.block_judicial_blocked': 'Judicial Blocked',
  'formLabels.customerChangeStatus': 'Account status',
  'formLabels.birth_date': 'Birth date',
  'formLabels.profile_age': 'Age',
  'formLabels.city_of_birth': 'City of birth',
  'formLabels.state_of_birth': 'State of birth',
  'formLabels.country_of_birth': 'Country of birth',
  'formLabels.document_type': 'Document number',
  'formLabels.document_type.rg': 'RG',
  'formLabels.document_type.cnh': 'CNH',
  'formLabels.other_id_number': 'Number',
  'formLabels.document_issued_at': 'State',
  'formLabels.document_issued_by': 'Issuer',
  'formLabels.document_issued_date': 'Issue date',
  'formLabels.mothers_name': "Mother's name",
  'formLabels.fathers_name': "Father's name",
  'formLabels.occupation': 'Occupation',
  'formLabels.income': 'Income',
  'formLabels.social_name': 'Social name',
  'formLabels.company_document_number': 'Tax id',
  'formLabels.company_registration_number': 'Registration number',
  'formLabels.company_activity': 'Activity',
  'formLabels.company_format': 'Format',
  'formLabels.company_type': 'Type',
  'formLabels.company_constitution_date': 'Constitution date',
  'formLabels.annual_revenues': 'Annual revenue',
  'formLabels.company_pep': 'PEP',
  'formLabels.fiscal_situation': 'Fiscal situation',
  'formLabels.number_of_partners': 'Number of partners',
  'formLabels.perc_ownership': 'Ownership percentage',
  'formLabels.net_worth': 'Net worth',
};

export default formLabels;
